// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/ai.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import {
  CompanyContextSection,
  companyContextSectionFromJSON,
  companyContextSectionToJSON,
  IssueAttachmentMetadata,
} from "./attachments";
import { ProjectEntityType, projectEntityTypeFromJSON, projectEntityTypeToJSON } from "./documents";
import { TicketProvider, ticketProviderFromJSON, ticketProviderToJSON } from "./integrations";
import { AgentType, agentTypeFromJSON, agentTypeToJSON } from "./threads";

export const protobufPackage = "api.devplan.types.ai";

export interface MessageToken {
  token: string;
  first: boolean;
  messageId: string;
}

export interface ChatSessionAction {
  type: { $case: "regenerate"; value: RegenerateAction } | undefined;
}

export interface RegenerateAction {
  /** Optional extra message for regeneration. */
  message?: string | undefined;
  withCleanUp?:
    | boolean
    | undefined;
  /** Extra params to be passed to the agent. */
  extraParams: { [key: string]: string };
}

export interface RegenerateAction_ExtraParamsEntry {
  key: string;
  value: string;
}

export interface AgentRunTask {
  companyId: number;
  action:
    | { $case: "generateDescription"; value: GenerateDescriptionTask }
    | { $case: "documentRegenerate"; value: DocumentRegenerateTask }
    | { $case: "processAttachment"; value: ProcessAttachmentTask }
    | undefined;
}

export interface UserMessage {
  id: string;
  message: string;
  imageUrls: string[];
  attachmentIds: string[];
  issueAttachments: IssueAttachmentMetadata[];
}

export interface RequestProcessedAck {
  id: string;
  error?: string | undefined;
}

export interface BackendDisconnected {
  error?: string | undefined;
}

export interface GenerateDescriptionTask {
  /** Known information about the entity excluding description. */
  entityInfo: string;
  currentDescription: string;
  projectId: string;
  entityType: ProjectEntityType;
  /** Id of the parent if exists. */
  parentId?:
    | string
    | undefined;
  /** Own id if entity already exists. */
  ownId?: string | undefined;
  userMessage?: string | undefined;
}

export interface DocumentRegenerateTask {
  projectId: string;
  documentId: string;
  agentType: AgentType;
  action: RegenerateAction | undefined;
}

export interface ProcessAttachmentTask {
  attachmentId: string;
  /** Optional project to attach the processed attachment to */
  projectId?:
    | string
    | undefined;
  /**
   * Optional company context section for company-info uploads.
   * When set, the resulting workspace AttachmentDetails is tagged with this
   * section while remaining company-level (not a workspace integration
   * attachment).
   */
  companyContextSection?:
    | CompanyContextSection
    | undefined;
  /**
   * When true, the resulting Attachment row is created as a workspace
   * integration attachment (integration_bucket set to the "workspace"
   * sentinel) so it feeds signals processing.
   */
  workspace: boolean;
}

export interface FullStateUpdate {
  /** JSON-serialized full state. State may not be present, in that case it will be not set. */
  newState?: string | undefined;
}

export interface PartialStateUpdate {
  /** Key is the key of the field and value is JSON serialized value. */
  updates: { [key: string]: PartialStateUpdate_Value };
}

export interface PartialStateUpdate_UpdatesEntry {
  key: string;
  value: PartialStateUpdate_Value | undefined;
}

export interface PartialStateUpdate_Value {
  val: string;
  json: boolean;
}

export interface TokenizedStateUpdate {
  stateKey: string;
  token:
    | MessageToken
    | undefined;
  /**
   * Ephemeral state update means that the state_key is not actually stored in DB
   * and will not be fetched with a full state update.
   */
  ephemeral: boolean;
}

export interface Message {
  id: string;
  createdAt: Date | undefined;
  content?: string | undefined;
  meta?: MessageMetadata | undefined;
  imageUrls: string[];
  attachmentIds: string[];
  issueAttachments: IssueAttachmentMetadata[];
  details: { $case: "ai"; value: AIMessageDetails } | { $case: "user"; value: UserMessageDetails } | {
    $case: "threadProgress";
    value: ThreadProgressMessageDetails;
  } | undefined;
}

export interface AIMessageDetails {
  /**
   * Project proposals produced by the propose_projects tool call. The agent
   * emits issue-link references as string keys; the client resolves them to
   * full IssueAttachmentMetadata before constructing this proto.
   */
  proposals: ProjectProposal[];
  ticketProposals: TicketProposal[];
}

/**
 * A batch of external ticket drafts emitted by one propose_tickets tool call.
 * The agent only proposes these values; creation requires an explicit action in
 * the web client.
 */
export interface TicketProposal {
  proposalId: string;
  tickets: ProposedTicket[];
}

export interface ProposedTicket {
  provider: TicketProvider;
  title: string;
  description: string;
  /**
   * Jira project key or Linear team id. The client supplies a current default
   * when the agent leaves this unset.
   */
  destinationId?: string | undefined;
  selected: boolean;
  createdTicketId?: string | undefined;
  createdTicketIdentifier?: string | undefined;
  createdTicketUrl?: string | undefined;
  creationError?:
    | string
    | undefined;
  /** Original tool value retained when it does not map to a supported enum. */
  providerValue: string;
}

/**
 * A batch of project candidates emitted together by a single propose_projects
 * tool call. `proposal_id` identifies the whole batch; individual projects
 * inside have no stable id and are addressed by position.
 */
export interface ProjectProposal {
  proposalId: string;
  projects: ProposedProject[];
}

export interface ProposedProject {
  title: string;
  description: string;
  /**
   * UUIDs of attachments (files, images, issue links) routed to this project
   * from earlier user messages in the scoping chat. Resolved against the
   * workspace attachments index at create time and copied into the new
   * project via the intake fan-out.
   */
  attachmentIds: string[];
  /** User-toggleable. Defaults to true on the agent's first emission. */
  selected: boolean;
  /**
   * Set once the user clicks Create. The agent reads this to know which
   * entries are already realized and skips re-proposing them.
   */
  createdProjectId?:
    | string
    | undefined;
  /** Project's own target / delivery date. */
  targetDate?:
    | Date
    | undefined;
  /**
   * Workspace user the agent recommends as owner. Match string (email or
   * display name); the client resolves it against the workspace user list at
   * create time.
   */
  assignee?:
    | string
    | undefined;
  /**
   * Release to assign the project to. Matched against existing workspace
   * releases by exact name; if no match exists, a new release is created
   * (with release_target_date if provided) before the project is created.
   */
  releaseName?: string | undefined;
  releaseTargetDate?: Date | undefined;
}

export interface UserMessageDetails {
  userId?: string | undefined;
}

export interface ThreadProgressMessageDetails {
}

export interface MessageMetadata {
  createdAt: Date | undefined;
  chatAction?: ChatSessionAction | undefined;
}

export interface SimpleAIAction {
  langfusePrompt: string;
  promptParams: { [key: string]: string };
}

export interface SimpleAIAction_PromptParamsEntry {
  key: string;
  value: string;
}

function createBaseMessageToken(): MessageToken {
  return { token: "", first: false, messageId: "" };
}

export const MessageToken: MessageFns<MessageToken> = {
  encode(message: MessageToken, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.first !== false) {
      writer.uint32(16).bool(message.first);
    }
    if (message.messageId !== "") {
      writer.uint32(26).string(message.messageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageToken {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.first = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.messageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageToken {
    return {
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      first: isSet(object.first) ? globalThis.Boolean(object.first) : false,
      messageId: isSet(object.messageId)
        ? globalThis.String(object.messageId)
        : isSet(object.message_id)
        ? globalThis.String(object.message_id)
        : "",
    };
  },

  toJSON(message: MessageToken): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.first !== false) {
      obj.first = message.first;
    }
    if (message.messageId !== "") {
      obj.messageId = message.messageId;
    }
    return obj;
  },

  create(base?: DeepPartial<MessageToken>): MessageToken {
    return MessageToken.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageToken>): MessageToken {
    const message = createBaseMessageToken();
    message.token = object.token ?? "";
    message.first = object.first ?? false;
    message.messageId = object.messageId ?? "";
    return message;
  },
};

function createBaseChatSessionAction(): ChatSessionAction {
  return { type: undefined };
}

export const ChatSessionAction: MessageFns<ChatSessionAction> = {
  encode(message: ChatSessionAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.type?.$case) {
      case "regenerate":
        RegenerateAction.encode(message.type.value, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatSessionAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatSessionAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = { $case: "regenerate", value: RegenerateAction.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatSessionAction {
    return {
      type: isSet(object.regenerate)
        ? { $case: "regenerate", value: RegenerateAction.fromJSON(object.regenerate) }
        : undefined,
    };
  },

  toJSON(message: ChatSessionAction): unknown {
    const obj: any = {};
    if (message.type?.$case === "regenerate") {
      obj.regenerate = RegenerateAction.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<ChatSessionAction>): ChatSessionAction {
    return ChatSessionAction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChatSessionAction>): ChatSessionAction {
    const message = createBaseChatSessionAction();
    switch (object.type?.$case) {
      case "regenerate": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "regenerate", value: RegenerateAction.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseRegenerateAction(): RegenerateAction {
  return { message: undefined, withCleanUp: undefined, extraParams: {} };
}

export const RegenerateAction: MessageFns<RegenerateAction> = {
  encode(message: RegenerateAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== undefined) {
      writer.uint32(10).string(message.message);
    }
    if (message.withCleanUp !== undefined) {
      writer.uint32(16).bool(message.withCleanUp);
    }
    globalThis.Object.entries(message.extraParams).forEach(([key, value]: [string, string]) => {
      RegenerateAction_ExtraParamsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegenerateAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegenerateAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.withCleanUp = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = RegenerateAction_ExtraParamsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.extraParams[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegenerateAction {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      withCleanUp: isSet(object.withCleanUp)
        ? globalThis.Boolean(object.withCleanUp)
        : isSet(object.with_clean_up)
        ? globalThis.Boolean(object.with_clean_up)
        : undefined,
      extraParams: isObject(object.extraParams)
        ? (globalThis.Object.entries(object.extraParams) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.extra_params)
        ? (globalThis.Object.entries(object.extra_params) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: RegenerateAction): unknown {
    const obj: any = {};
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.withCleanUp !== undefined) {
      obj.withCleanUp = message.withCleanUp;
    }
    if (message.extraParams) {
      const entries = globalThis.Object.entries(message.extraParams) as [string, string][];
      if (entries.length > 0) {
        obj.extraParams = {};
        entries.forEach(([k, v]) => {
          obj.extraParams[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<RegenerateAction>): RegenerateAction {
    return RegenerateAction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RegenerateAction>): RegenerateAction {
    const message = createBaseRegenerateAction();
    message.message = object.message ?? undefined;
    message.withCleanUp = object.withCleanUp ?? undefined;
    message.extraParams = (globalThis.Object.entries(object.extraParams ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRegenerateAction_ExtraParamsEntry(): RegenerateAction_ExtraParamsEntry {
  return { key: "", value: "" };
}

export const RegenerateAction_ExtraParamsEntry: MessageFns<RegenerateAction_ExtraParamsEntry> = {
  encode(message: RegenerateAction_ExtraParamsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegenerateAction_ExtraParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegenerateAction_ExtraParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegenerateAction_ExtraParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: RegenerateAction_ExtraParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RegenerateAction_ExtraParamsEntry>): RegenerateAction_ExtraParamsEntry {
    return RegenerateAction_ExtraParamsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RegenerateAction_ExtraParamsEntry>): RegenerateAction_ExtraParamsEntry {
    const message = createBaseRegenerateAction_ExtraParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAgentRunTask(): AgentRunTask {
  return { companyId: 0, action: undefined };
}

export const AgentRunTask: MessageFns<AgentRunTask> = {
  encode(message: AgentRunTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    switch (message.action?.$case) {
      case "generateDescription":
        GenerateDescriptionTask.encode(message.action.value, writer.uint32(802).fork()).join();
        break;
      case "documentRegenerate":
        DocumentRegenerateTask.encode(message.action.value, writer.uint32(810).fork()).join();
        break;
      case "processAttachment":
        ProcessAttachmentTask.encode(message.action.value, writer.uint32(818).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentRunTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentRunTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.action = {
            $case: "generateDescription",
            value: GenerateDescriptionTask.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.action = {
            $case: "documentRegenerate",
            value: DocumentRegenerateTask.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.action = { $case: "processAttachment", value: ProcessAttachmentTask.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentRunTask {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      action: isSet(object.generateDescription)
        ? { $case: "generateDescription", value: GenerateDescriptionTask.fromJSON(object.generateDescription) }
        : isSet(object.generate_description)
        ? { $case: "generateDescription", value: GenerateDescriptionTask.fromJSON(object.generate_description) }
        : isSet(object.documentRegenerate)
        ? { $case: "documentRegenerate", value: DocumentRegenerateTask.fromJSON(object.documentRegenerate) }
        : isSet(object.document_regenerate)
        ? { $case: "documentRegenerate", value: DocumentRegenerateTask.fromJSON(object.document_regenerate) }
        : isSet(object.processAttachment)
        ? { $case: "processAttachment", value: ProcessAttachmentTask.fromJSON(object.processAttachment) }
        : isSet(object.process_attachment)
        ? { $case: "processAttachment", value: ProcessAttachmentTask.fromJSON(object.process_attachment) }
        : undefined,
    };
  },

  toJSON(message: AgentRunTask): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.action?.$case === "generateDescription") {
      obj.generateDescription = GenerateDescriptionTask.toJSON(message.action.value);
    } else if (message.action?.$case === "documentRegenerate") {
      obj.documentRegenerate = DocumentRegenerateTask.toJSON(message.action.value);
    } else if (message.action?.$case === "processAttachment") {
      obj.processAttachment = ProcessAttachmentTask.toJSON(message.action.value);
    }
    return obj;
  },

  create(base?: DeepPartial<AgentRunTask>): AgentRunTask {
    return AgentRunTask.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AgentRunTask>): AgentRunTask {
    const message = createBaseAgentRunTask();
    message.companyId = object.companyId ?? 0;
    switch (object.action?.$case) {
      case "generateDescription": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = {
            $case: "generateDescription",
            value: GenerateDescriptionTask.fromPartial(object.action.value),
          };
        }
        break;
      }
      case "documentRegenerate": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = {
            $case: "documentRegenerate",
            value: DocumentRegenerateTask.fromPartial(object.action.value),
          };
        }
        break;
      }
      case "processAttachment": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = {
            $case: "processAttachment",
            value: ProcessAttachmentTask.fromPartial(object.action.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUserMessage(): UserMessage {
  return { id: "", message: "", imageUrls: [], attachmentIds: [], issueAttachments: [] };
}

export const UserMessage: MessageFns<UserMessage> = {
  encode(message: UserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    for (const v of message.imageUrls) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.attachmentIds) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.issueAttachments) {
      IssueAttachmentMetadata.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.imageUrls.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.attachmentIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.issueAttachments.push(IssueAttachmentMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      imageUrls: globalThis.Array.isArray(object?.imageUrls)
        ? object.imageUrls.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.image_urls)
        ? object.image_urls.map((e: any) => globalThis.String(e))
        : [],
      attachmentIds: globalThis.Array.isArray(object?.attachmentIds)
        ? object.attachmentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachment_ids)
        ? object.attachment_ids.map((e: any) => globalThis.String(e))
        : [],
      issueAttachments: globalThis.Array.isArray(object?.issueAttachments)
        ? object.issueAttachments.map((e: any) => IssueAttachmentMetadata.fromJSON(e))
        : globalThis.Array.isArray(object?.issue_attachments)
        ? object.issue_attachments.map((e: any) => IssueAttachmentMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.imageUrls?.length) {
      obj.imageUrls = message.imageUrls;
    }
    if (message.attachmentIds?.length) {
      obj.attachmentIds = message.attachmentIds;
    }
    if (message.issueAttachments?.length) {
      obj.issueAttachments = message.issueAttachments.map((e) => IssueAttachmentMetadata.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<UserMessage>): UserMessage {
    return UserMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserMessage>): UserMessage {
    const message = createBaseUserMessage();
    message.id = object.id ?? "";
    message.message = object.message ?? "";
    message.imageUrls = object.imageUrls?.map((e) => e) || [];
    message.attachmentIds = object.attachmentIds?.map((e) => e) || [];
    message.issueAttachments = object.issueAttachments?.map((e) => IssueAttachmentMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRequestProcessedAck(): RequestProcessedAck {
  return { id: "", error: undefined };
}

export const RequestProcessedAck: MessageFns<RequestProcessedAck> = {
  encode(message: RequestProcessedAck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.error !== undefined) {
      writer.uint32(18).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestProcessedAck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestProcessedAck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestProcessedAck {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: RequestProcessedAck): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<RequestProcessedAck>): RequestProcessedAck {
    return RequestProcessedAck.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RequestProcessedAck>): RequestProcessedAck {
    const message = createBaseRequestProcessedAck();
    message.id = object.id ?? "";
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseBackendDisconnected(): BackendDisconnected {
  return { error: undefined };
}

export const BackendDisconnected: MessageFns<BackendDisconnected> = {
  encode(message: BackendDisconnected, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.error !== undefined) {
      writer.uint32(10).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackendDisconnected {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBackendDisconnected();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BackendDisconnected {
    return { error: isSet(object.error) ? globalThis.String(object.error) : undefined };
  },

  toJSON(message: BackendDisconnected): unknown {
    const obj: any = {};
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<BackendDisconnected>): BackendDisconnected {
    return BackendDisconnected.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BackendDisconnected>): BackendDisconnected {
    const message = createBaseBackendDisconnected();
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseGenerateDescriptionTask(): GenerateDescriptionTask {
  return {
    entityInfo: "",
    currentDescription: "",
    projectId: "",
    entityType: 0,
    parentId: undefined,
    ownId: undefined,
    userMessage: undefined,
  };
}

export const GenerateDescriptionTask: MessageFns<GenerateDescriptionTask> = {
  encode(message: GenerateDescriptionTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entityInfo !== "") {
      writer.uint32(10).string(message.entityInfo);
    }
    if (message.currentDescription !== "") {
      writer.uint32(18).string(message.currentDescription);
    }
    if (message.projectId !== "") {
      writer.uint32(26).string(message.projectId);
    }
    if (message.entityType !== 0) {
      writer.uint32(32).int32(message.entityType);
    }
    if (message.parentId !== undefined) {
      writer.uint32(42).string(message.parentId);
    }
    if (message.ownId !== undefined) {
      writer.uint32(50).string(message.ownId);
    }
    if (message.userMessage !== undefined) {
      writer.uint32(58).string(message.userMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateDescriptionTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateDescriptionTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entityInfo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentDescription = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.entityType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ownId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.userMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateDescriptionTask {
    return {
      entityInfo: isSet(object.entityInfo)
        ? globalThis.String(object.entityInfo)
        : isSet(object.entity_info)
        ? globalThis.String(object.entity_info)
        : "",
      currentDescription: isSet(object.currentDescription)
        ? globalThis.String(object.currentDescription)
        : isSet(object.current_description)
        ? globalThis.String(object.current_description)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      entityType: isSet(object.entityType)
        ? projectEntityTypeFromJSON(object.entityType)
        : isSet(object.entity_type)
        ? projectEntityTypeFromJSON(object.entity_type)
        : 0,
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
      ownId: isSet(object.ownId)
        ? globalThis.String(object.ownId)
        : isSet(object.own_id)
        ? globalThis.String(object.own_id)
        : undefined,
      userMessage: isSet(object.userMessage)
        ? globalThis.String(object.userMessage)
        : isSet(object.user_message)
        ? globalThis.String(object.user_message)
        : undefined,
    };
  },

  toJSON(message: GenerateDescriptionTask): unknown {
    const obj: any = {};
    if (message.entityInfo !== "") {
      obj.entityInfo = message.entityInfo;
    }
    if (message.currentDescription !== "") {
      obj.currentDescription = message.currentDescription;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.entityType !== 0) {
      obj.entityType = projectEntityTypeToJSON(message.entityType);
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.ownId !== undefined) {
      obj.ownId = message.ownId;
    }
    if (message.userMessage !== undefined) {
      obj.userMessage = message.userMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateDescriptionTask>): GenerateDescriptionTask {
    return GenerateDescriptionTask.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateDescriptionTask>): GenerateDescriptionTask {
    const message = createBaseGenerateDescriptionTask();
    message.entityInfo = object.entityInfo ?? "";
    message.currentDescription = object.currentDescription ?? "";
    message.projectId = object.projectId ?? "";
    message.entityType = object.entityType ?? 0;
    message.parentId = object.parentId ?? undefined;
    message.ownId = object.ownId ?? undefined;
    message.userMessage = object.userMessage ?? undefined;
    return message;
  },
};

function createBaseDocumentRegenerateTask(): DocumentRegenerateTask {
  return { projectId: "", documentId: "", agentType: 0, action: undefined };
}

export const DocumentRegenerateTask: MessageFns<DocumentRegenerateTask> = {
  encode(message: DocumentRegenerateTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectId !== "") {
      writer.uint32(10).string(message.projectId);
    }
    if (message.documentId !== "") {
      writer.uint32(18).string(message.documentId);
    }
    if (message.agentType !== 0) {
      writer.uint32(24).int32(message.agentType);
    }
    if (message.action !== undefined) {
      RegenerateAction.encode(message.action, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentRegenerateTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentRegenerateTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.agentType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.action = RegenerateAction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentRegenerateTask {
    return {
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      agentType: isSet(object.agentType)
        ? agentTypeFromJSON(object.agentType)
        : isSet(object.agent_type)
        ? agentTypeFromJSON(object.agent_type)
        : 0,
      action: isSet(object.action) ? RegenerateAction.fromJSON(object.action) : undefined,
    };
  },

  toJSON(message: DocumentRegenerateTask): unknown {
    const obj: any = {};
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.agentType !== 0) {
      obj.agentType = agentTypeToJSON(message.agentType);
    }
    if (message.action !== undefined) {
      obj.action = RegenerateAction.toJSON(message.action);
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentRegenerateTask>): DocumentRegenerateTask {
    return DocumentRegenerateTask.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentRegenerateTask>): DocumentRegenerateTask {
    const message = createBaseDocumentRegenerateTask();
    message.projectId = object.projectId ?? "";
    message.documentId = object.documentId ?? "";
    message.agentType = object.agentType ?? 0;
    message.action = (object.action !== undefined && object.action !== null)
      ? RegenerateAction.fromPartial(object.action)
      : undefined;
    return message;
  },
};

function createBaseProcessAttachmentTask(): ProcessAttachmentTask {
  return { attachmentId: "", projectId: undefined, companyContextSection: undefined, workspace: false };
}

export const ProcessAttachmentTask: MessageFns<ProcessAttachmentTask> = {
  encode(message: ProcessAttachmentTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentId !== "") {
      writer.uint32(10).string(message.attachmentId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(26).string(message.projectId);
    }
    if (message.companyContextSection !== undefined) {
      writer.uint32(40).int32(message.companyContextSection);
    }
    if (message.workspace !== false) {
      writer.uint32(48).bool(message.workspace);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessAttachmentTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessAttachmentTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.companyContextSection = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.workspace = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessAttachmentTask {
    return {
      attachmentId: isSet(object.attachmentId)
        ? globalThis.String(object.attachmentId)
        : isSet(object.attachment_id)
        ? globalThis.String(object.attachment_id)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      companyContextSection: isSet(object.companyContextSection)
        ? companyContextSectionFromJSON(object.companyContextSection)
        : isSet(object.company_context_section)
        ? companyContextSectionFromJSON(object.company_context_section)
        : undefined,
      workspace: isSet(object.workspace) ? globalThis.Boolean(object.workspace) : false,
    };
  },

  toJSON(message: ProcessAttachmentTask): unknown {
    const obj: any = {};
    if (message.attachmentId !== "") {
      obj.attachmentId = message.attachmentId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.companyContextSection !== undefined) {
      obj.companyContextSection = companyContextSectionToJSON(message.companyContextSection);
    }
    if (message.workspace !== false) {
      obj.workspace = message.workspace;
    }
    return obj;
  },

  create(base?: DeepPartial<ProcessAttachmentTask>): ProcessAttachmentTask {
    return ProcessAttachmentTask.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessAttachmentTask>): ProcessAttachmentTask {
    const message = createBaseProcessAttachmentTask();
    message.attachmentId = object.attachmentId ?? "";
    message.projectId = object.projectId ?? undefined;
    message.companyContextSection = object.companyContextSection ?? undefined;
    message.workspace = object.workspace ?? false;
    return message;
  },
};

function createBaseFullStateUpdate(): FullStateUpdate {
  return { newState: undefined };
}

export const FullStateUpdate: MessageFns<FullStateUpdate> = {
  encode(message: FullStateUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.newState !== undefined) {
      writer.uint32(10).string(message.newState);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FullStateUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFullStateUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.newState = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FullStateUpdate {
    return {
      newState: isSet(object.newState)
        ? globalThis.String(object.newState)
        : isSet(object.new_state)
        ? globalThis.String(object.new_state)
        : undefined,
    };
  },

  toJSON(message: FullStateUpdate): unknown {
    const obj: any = {};
    if (message.newState !== undefined) {
      obj.newState = message.newState;
    }
    return obj;
  },

  create(base?: DeepPartial<FullStateUpdate>): FullStateUpdate {
    return FullStateUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FullStateUpdate>): FullStateUpdate {
    const message = createBaseFullStateUpdate();
    message.newState = object.newState ?? undefined;
    return message;
  },
};

function createBasePartialStateUpdate(): PartialStateUpdate {
  return { updates: {} };
}

export const PartialStateUpdate: MessageFns<PartialStateUpdate> = {
  encode(message: PartialStateUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.updates).forEach(([key, value]: [string, PartialStateUpdate_Value]) => {
      PartialStateUpdate_UpdatesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartialStateUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartialStateUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = PartialStateUpdate_UpdatesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.updates[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartialStateUpdate {
    return {
      updates: isObject(object.updates)
        ? (globalThis.Object.entries(object.updates) as [string, any][]).reduce(
          (acc: { [key: string]: PartialStateUpdate_Value }, [key, value]: [string, any]) => {
            acc[key] = PartialStateUpdate_Value.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: PartialStateUpdate): unknown {
    const obj: any = {};
    if (message.updates) {
      const entries = globalThis.Object.entries(message.updates) as [string, PartialStateUpdate_Value][];
      if (entries.length > 0) {
        obj.updates = {};
        entries.forEach(([k, v]) => {
          obj.updates[k] = PartialStateUpdate_Value.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<PartialStateUpdate>): PartialStateUpdate {
    return PartialStateUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PartialStateUpdate>): PartialStateUpdate {
    const message = createBasePartialStateUpdate();
    message.updates = (globalThis.Object.entries(object.updates ?? {}) as [string, PartialStateUpdate_Value][]).reduce(
      (acc: { [key: string]: PartialStateUpdate_Value }, [key, value]: [string, PartialStateUpdate_Value]) => {
        if (value !== undefined) {
          acc[key] = PartialStateUpdate_Value.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePartialStateUpdate_UpdatesEntry(): PartialStateUpdate_UpdatesEntry {
  return { key: "", value: undefined };
}

export const PartialStateUpdate_UpdatesEntry: MessageFns<PartialStateUpdate_UpdatesEntry> = {
  encode(message: PartialStateUpdate_UpdatesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      PartialStateUpdate_Value.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartialStateUpdate_UpdatesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartialStateUpdate_UpdatesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = PartialStateUpdate_Value.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartialStateUpdate_UpdatesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? PartialStateUpdate_Value.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PartialStateUpdate_UpdatesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = PartialStateUpdate_Value.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<PartialStateUpdate_UpdatesEntry>): PartialStateUpdate_UpdatesEntry {
    return PartialStateUpdate_UpdatesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PartialStateUpdate_UpdatesEntry>): PartialStateUpdate_UpdatesEntry {
    const message = createBasePartialStateUpdate_UpdatesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? PartialStateUpdate_Value.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePartialStateUpdate_Value(): PartialStateUpdate_Value {
  return { val: "", json: false };
}

export const PartialStateUpdate_Value: MessageFns<PartialStateUpdate_Value> = {
  encode(message: PartialStateUpdate_Value, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.val !== "") {
      writer.uint32(10).string(message.val);
    }
    if (message.json !== false) {
      writer.uint32(16).bool(message.json);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartialStateUpdate_Value {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartialStateUpdate_Value();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.val = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.json = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartialStateUpdate_Value {
    return {
      val: isSet(object.val) ? globalThis.String(object.val) : "",
      json: isSet(object.json) ? globalThis.Boolean(object.json) : false,
    };
  },

  toJSON(message: PartialStateUpdate_Value): unknown {
    const obj: any = {};
    if (message.val !== "") {
      obj.val = message.val;
    }
    if (message.json !== false) {
      obj.json = message.json;
    }
    return obj;
  },

  create(base?: DeepPartial<PartialStateUpdate_Value>): PartialStateUpdate_Value {
    return PartialStateUpdate_Value.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PartialStateUpdate_Value>): PartialStateUpdate_Value {
    const message = createBasePartialStateUpdate_Value();
    message.val = object.val ?? "";
    message.json = object.json ?? false;
    return message;
  },
};

function createBaseTokenizedStateUpdate(): TokenizedStateUpdate {
  return { stateKey: "", token: undefined, ephemeral: false };
}

export const TokenizedStateUpdate: MessageFns<TokenizedStateUpdate> = {
  encode(message: TokenizedStateUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stateKey !== "") {
      writer.uint32(10).string(message.stateKey);
    }
    if (message.token !== undefined) {
      MessageToken.encode(message.token, writer.uint32(18).fork()).join();
    }
    if (message.ephemeral !== false) {
      writer.uint32(24).bool(message.ephemeral);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenizedStateUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokenizedStateUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stateKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.token = MessageToken.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ephemeral = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TokenizedStateUpdate {
    return {
      stateKey: isSet(object.stateKey)
        ? globalThis.String(object.stateKey)
        : isSet(object.state_key)
        ? globalThis.String(object.state_key)
        : "",
      token: isSet(object.token) ? MessageToken.fromJSON(object.token) : undefined,
      ephemeral: isSet(object.ephemeral) ? globalThis.Boolean(object.ephemeral) : false,
    };
  },

  toJSON(message: TokenizedStateUpdate): unknown {
    const obj: any = {};
    if (message.stateKey !== "") {
      obj.stateKey = message.stateKey;
    }
    if (message.token !== undefined) {
      obj.token = MessageToken.toJSON(message.token);
    }
    if (message.ephemeral !== false) {
      obj.ephemeral = message.ephemeral;
    }
    return obj;
  },

  create(base?: DeepPartial<TokenizedStateUpdate>): TokenizedStateUpdate {
    return TokenizedStateUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TokenizedStateUpdate>): TokenizedStateUpdate {
    const message = createBaseTokenizedStateUpdate();
    message.stateKey = object.stateKey ?? "";
    message.token = (object.token !== undefined && object.token !== null)
      ? MessageToken.fromPartial(object.token)
      : undefined;
    message.ephemeral = object.ephemeral ?? false;
    return message;
  },
};

function createBaseMessage(): Message {
  return {
    id: "",
    createdAt: undefined,
    content: undefined,
    meta: undefined,
    imageUrls: [],
    attachmentIds: [],
    issueAttachments: [],
    details: undefined,
  };
}

export const Message: MessageFns<Message> = {
  encode(message: Message, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.content !== undefined) {
      writer.uint32(26).string(message.content);
    }
    if (message.meta !== undefined) {
      MessageMetadata.encode(message.meta, writer.uint32(34).fork()).join();
    }
    for (const v of message.imageUrls) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.attachmentIds) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.issueAttachments) {
      IssueAttachmentMetadata.encode(v!, writer.uint32(66).fork()).join();
    }
    switch (message.details?.$case) {
      case "ai":
        AIMessageDetails.encode(message.details.value, writer.uint32(802).fork()).join();
        break;
      case "user":
        UserMessageDetails.encode(message.details.value, writer.uint32(810).fork()).join();
        break;
      case "threadProgress":
        ThreadProgressMessageDetails.encode(message.details.value, writer.uint32(818).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Message {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.meta = MessageMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.imageUrls.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.attachmentIds.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.issueAttachments.push(IssueAttachmentMetadata.decode(reader, reader.uint32()));
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.details = { $case: "ai", value: AIMessageDetails.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.details = { $case: "user", value: UserMessageDetails.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.details = {
            $case: "threadProgress",
            value: ThreadProgressMessageDetails.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Message {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      meta: isSet(object.meta) ? MessageMetadata.fromJSON(object.meta) : undefined,
      imageUrls: globalThis.Array.isArray(object?.imageUrls)
        ? object.imageUrls.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.image_urls)
        ? object.image_urls.map((e: any) => globalThis.String(e))
        : [],
      attachmentIds: globalThis.Array.isArray(object?.attachmentIds)
        ? object.attachmentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachment_ids)
        ? object.attachment_ids.map((e: any) => globalThis.String(e))
        : [],
      issueAttachments: globalThis.Array.isArray(object?.issueAttachments)
        ? object.issueAttachments.map((e: any) => IssueAttachmentMetadata.fromJSON(e))
        : globalThis.Array.isArray(object?.issue_attachments)
        ? object.issue_attachments.map((e: any) => IssueAttachmentMetadata.fromJSON(e))
        : [],
      details: isSet(object.ai)
        ? { $case: "ai", value: AIMessageDetails.fromJSON(object.ai) }
        : isSet(object.user)
        ? { $case: "user", value: UserMessageDetails.fromJSON(object.user) }
        : isSet(object.threadProgress)
        ? { $case: "threadProgress", value: ThreadProgressMessageDetails.fromJSON(object.threadProgress) }
        : isSet(object.thread_progress)
        ? { $case: "threadProgress", value: ThreadProgressMessageDetails.fromJSON(object.thread_progress) }
        : undefined,
    };
  },

  toJSON(message: Message): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.meta !== undefined) {
      obj.meta = MessageMetadata.toJSON(message.meta);
    }
    if (message.imageUrls?.length) {
      obj.imageUrls = message.imageUrls;
    }
    if (message.attachmentIds?.length) {
      obj.attachmentIds = message.attachmentIds;
    }
    if (message.issueAttachments?.length) {
      obj.issueAttachments = message.issueAttachments.map((e) => IssueAttachmentMetadata.toJSON(e));
    }
    if (message.details?.$case === "ai") {
      obj.ai = AIMessageDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "user") {
      obj.user = UserMessageDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "threadProgress") {
      obj.threadProgress = ThreadProgressMessageDetails.toJSON(message.details.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Message>): Message {
    return Message.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Message>): Message {
    const message = createBaseMessage();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.content = object.content ?? undefined;
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? MessageMetadata.fromPartial(object.meta)
      : undefined;
    message.imageUrls = object.imageUrls?.map((e) => e) || [];
    message.attachmentIds = object.attachmentIds?.map((e) => e) || [];
    message.issueAttachments = object.issueAttachments?.map((e) => IssueAttachmentMetadata.fromPartial(e)) || [];
    switch (object.details?.$case) {
      case "ai": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = { $case: "ai", value: AIMessageDetails.fromPartial(object.details.value) };
        }
        break;
      }
      case "user": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = { $case: "user", value: UserMessageDetails.fromPartial(object.details.value) };
        }
        break;
      }
      case "threadProgress": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = {
            $case: "threadProgress",
            value: ThreadProgressMessageDetails.fromPartial(object.details.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseAIMessageDetails(): AIMessageDetails {
  return { proposals: [], ticketProposals: [] };
}

export const AIMessageDetails: MessageFns<AIMessageDetails> = {
  encode(message: AIMessageDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.proposals) {
      ProjectProposal.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.ticketProposals) {
      TicketProposal.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AIMessageDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAIMessageDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.proposals.push(ProjectProposal.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ticketProposals.push(TicketProposal.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AIMessageDetails {
    return {
      proposals: globalThis.Array.isArray(object?.proposals)
        ? object.proposals.map((e: any) => ProjectProposal.fromJSON(e))
        : [],
      ticketProposals: globalThis.Array.isArray(object?.ticketProposals)
        ? object.ticketProposals.map((e: any) => TicketProposal.fromJSON(e))
        : globalThis.Array.isArray(object?.ticket_proposals)
        ? object.ticket_proposals.map((e: any) => TicketProposal.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AIMessageDetails): unknown {
    const obj: any = {};
    if (message.proposals?.length) {
      obj.proposals = message.proposals.map((e) => ProjectProposal.toJSON(e));
    }
    if (message.ticketProposals?.length) {
      obj.ticketProposals = message.ticketProposals.map((e) => TicketProposal.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<AIMessageDetails>): AIMessageDetails {
    return AIMessageDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AIMessageDetails>): AIMessageDetails {
    const message = createBaseAIMessageDetails();
    message.proposals = object.proposals?.map((e) => ProjectProposal.fromPartial(e)) || [];
    message.ticketProposals = object.ticketProposals?.map((e) => TicketProposal.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTicketProposal(): TicketProposal {
  return { proposalId: "", tickets: [] };
}

export const TicketProposal: MessageFns<TicketProposal> = {
  encode(message: TicketProposal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.proposalId !== "") {
      writer.uint32(10).string(message.proposalId);
    }
    for (const v of message.tickets) {
      ProposedTicket.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TicketProposal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTicketProposal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.proposalId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tickets.push(ProposedTicket.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TicketProposal {
    return {
      proposalId: isSet(object.proposalId)
        ? globalThis.String(object.proposalId)
        : isSet(object.proposal_id)
        ? globalThis.String(object.proposal_id)
        : "",
      tickets: globalThis.Array.isArray(object?.tickets)
        ? object.tickets.map((e: any) => ProposedTicket.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TicketProposal): unknown {
    const obj: any = {};
    if (message.proposalId !== "") {
      obj.proposalId = message.proposalId;
    }
    if (message.tickets?.length) {
      obj.tickets = message.tickets.map((e) => ProposedTicket.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TicketProposal>): TicketProposal {
    return TicketProposal.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TicketProposal>): TicketProposal {
    const message = createBaseTicketProposal();
    message.proposalId = object.proposalId ?? "";
    message.tickets = object.tickets?.map((e) => ProposedTicket.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProposedTicket(): ProposedTicket {
  return {
    provider: 0,
    title: "",
    description: "",
    destinationId: undefined,
    selected: false,
    createdTicketId: undefined,
    createdTicketIdentifier: undefined,
    createdTicketUrl: undefined,
    creationError: undefined,
    providerValue: "",
  };
}

export const ProposedTicket: MessageFns<ProposedTicket> = {
  encode(message: ProposedTicket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== 0) {
      writer.uint32(8).int32(message.provider);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.destinationId !== undefined) {
      writer.uint32(34).string(message.destinationId);
    }
    if (message.selected !== false) {
      writer.uint32(40).bool(message.selected);
    }
    if (message.createdTicketId !== undefined) {
      writer.uint32(50).string(message.createdTicketId);
    }
    if (message.createdTicketIdentifier !== undefined) {
      writer.uint32(58).string(message.createdTicketIdentifier);
    }
    if (message.createdTicketUrl !== undefined) {
      writer.uint32(66).string(message.createdTicketUrl);
    }
    if (message.creationError !== undefined) {
      writer.uint32(74).string(message.creationError);
    }
    if (message.providerValue !== "") {
      writer.uint32(82).string(message.providerValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProposedTicket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProposedTicket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.destinationId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdTicketId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdTicketIdentifier = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdTicketUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.creationError = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.providerValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProposedTicket {
    return {
      provider: isSet(object.provider) ? ticketProviderFromJSON(object.provider) : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      destinationId: isSet(object.destinationId)
        ? globalThis.String(object.destinationId)
        : isSet(object.destination_id)
        ? globalThis.String(object.destination_id)
        : undefined,
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : false,
      createdTicketId: isSet(object.createdTicketId)
        ? globalThis.String(object.createdTicketId)
        : isSet(object.created_ticket_id)
        ? globalThis.String(object.created_ticket_id)
        : undefined,
      createdTicketIdentifier: isSet(object.createdTicketIdentifier)
        ? globalThis.String(object.createdTicketIdentifier)
        : isSet(object.created_ticket_identifier)
        ? globalThis.String(object.created_ticket_identifier)
        : undefined,
      createdTicketUrl: isSet(object.createdTicketUrl)
        ? globalThis.String(object.createdTicketUrl)
        : isSet(object.created_ticket_url)
        ? globalThis.String(object.created_ticket_url)
        : undefined,
      creationError: isSet(object.creationError)
        ? globalThis.String(object.creationError)
        : isSet(object.creation_error)
        ? globalThis.String(object.creation_error)
        : undefined,
      providerValue: isSet(object.providerValue)
        ? globalThis.String(object.providerValue)
        : isSet(object.provider_value)
        ? globalThis.String(object.provider_value)
        : "",
    };
  },

  toJSON(message: ProposedTicket): unknown {
    const obj: any = {};
    if (message.provider !== 0) {
      obj.provider = ticketProviderToJSON(message.provider);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.destinationId !== undefined) {
      obj.destinationId = message.destinationId;
    }
    if (message.selected !== false) {
      obj.selected = message.selected;
    }
    if (message.createdTicketId !== undefined) {
      obj.createdTicketId = message.createdTicketId;
    }
    if (message.createdTicketIdentifier !== undefined) {
      obj.createdTicketIdentifier = message.createdTicketIdentifier;
    }
    if (message.createdTicketUrl !== undefined) {
      obj.createdTicketUrl = message.createdTicketUrl;
    }
    if (message.creationError !== undefined) {
      obj.creationError = message.creationError;
    }
    if (message.providerValue !== "") {
      obj.providerValue = message.providerValue;
    }
    return obj;
  },

  create(base?: DeepPartial<ProposedTicket>): ProposedTicket {
    return ProposedTicket.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProposedTicket>): ProposedTicket {
    const message = createBaseProposedTicket();
    message.provider = object.provider ?? 0;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.destinationId = object.destinationId ?? undefined;
    message.selected = object.selected ?? false;
    message.createdTicketId = object.createdTicketId ?? undefined;
    message.createdTicketIdentifier = object.createdTicketIdentifier ?? undefined;
    message.createdTicketUrl = object.createdTicketUrl ?? undefined;
    message.creationError = object.creationError ?? undefined;
    message.providerValue = object.providerValue ?? "";
    return message;
  },
};

function createBaseProjectProposal(): ProjectProposal {
  return { proposalId: "", projects: [] };
}

export const ProjectProposal: MessageFns<ProjectProposal> = {
  encode(message: ProjectProposal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.proposalId !== "") {
      writer.uint32(10).string(message.proposalId);
    }
    for (const v of message.projects) {
      ProposedProject.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectProposal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectProposal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.proposalId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projects.push(ProposedProject.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectProposal {
    return {
      proposalId: isSet(object.proposalId)
        ? globalThis.String(object.proposalId)
        : isSet(object.proposal_id)
        ? globalThis.String(object.proposal_id)
        : "",
      projects: globalThis.Array.isArray(object?.projects)
        ? object.projects.map((e: any) => ProposedProject.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ProjectProposal): unknown {
    const obj: any = {};
    if (message.proposalId !== "") {
      obj.proposalId = message.proposalId;
    }
    if (message.projects?.length) {
      obj.projects = message.projects.map((e) => ProposedProject.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectProposal>): ProjectProposal {
    return ProjectProposal.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectProposal>): ProjectProposal {
    const message = createBaseProjectProposal();
    message.proposalId = object.proposalId ?? "";
    message.projects = object.projects?.map((e) => ProposedProject.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProposedProject(): ProposedProject {
  return {
    title: "",
    description: "",
    attachmentIds: [],
    selected: false,
    createdProjectId: undefined,
    targetDate: undefined,
    assignee: undefined,
    releaseName: undefined,
    releaseTargetDate: undefined,
  };
}

export const ProposedProject: MessageFns<ProposedProject> = {
  encode(message: ProposedProject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    for (const v of message.attachmentIds) {
      writer.uint32(26).string(v!);
    }
    if (message.selected !== false) {
      writer.uint32(32).bool(message.selected);
    }
    if (message.createdProjectId !== undefined) {
      writer.uint32(42).string(message.createdProjectId);
    }
    if (message.targetDate !== undefined) {
      Timestamp.encode(toTimestamp(message.targetDate), writer.uint32(50).fork()).join();
    }
    if (message.assignee !== undefined) {
      writer.uint32(58).string(message.assignee);
    }
    if (message.releaseName !== undefined) {
      writer.uint32(66).string(message.releaseName);
    }
    if (message.releaseTargetDate !== undefined) {
      Timestamp.encode(toTimestamp(message.releaseTargetDate), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProposedProject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProposedProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attachmentIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdProjectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.targetDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.assignee = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.releaseName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.releaseTargetDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProposedProject {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      attachmentIds: globalThis.Array.isArray(object?.attachmentIds)
        ? object.attachmentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachment_ids)
        ? object.attachment_ids.map((e: any) => globalThis.String(e))
        : [],
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : false,
      createdProjectId: isSet(object.createdProjectId)
        ? globalThis.String(object.createdProjectId)
        : isSet(object.created_project_id)
        ? globalThis.String(object.created_project_id)
        : undefined,
      targetDate: isSet(object.targetDate)
        ? fromJsonTimestamp(object.targetDate)
        : isSet(object.target_date)
        ? fromJsonTimestamp(object.target_date)
        : undefined,
      assignee: isSet(object.assignee) ? globalThis.String(object.assignee) : undefined,
      releaseName: isSet(object.releaseName)
        ? globalThis.String(object.releaseName)
        : isSet(object.release_name)
        ? globalThis.String(object.release_name)
        : undefined,
      releaseTargetDate: isSet(object.releaseTargetDate)
        ? fromJsonTimestamp(object.releaseTargetDate)
        : isSet(object.release_target_date)
        ? fromJsonTimestamp(object.release_target_date)
        : undefined,
    };
  },

  toJSON(message: ProposedProject): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.attachmentIds?.length) {
      obj.attachmentIds = message.attachmentIds;
    }
    if (message.selected !== false) {
      obj.selected = message.selected;
    }
    if (message.createdProjectId !== undefined) {
      obj.createdProjectId = message.createdProjectId;
    }
    if (message.targetDate !== undefined) {
      obj.targetDate = message.targetDate.toISOString();
    }
    if (message.assignee !== undefined) {
      obj.assignee = message.assignee;
    }
    if (message.releaseName !== undefined) {
      obj.releaseName = message.releaseName;
    }
    if (message.releaseTargetDate !== undefined) {
      obj.releaseTargetDate = message.releaseTargetDate.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ProposedProject>): ProposedProject {
    return ProposedProject.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProposedProject>): ProposedProject {
    const message = createBaseProposedProject();
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.attachmentIds = object.attachmentIds?.map((e) => e) || [];
    message.selected = object.selected ?? false;
    message.createdProjectId = object.createdProjectId ?? undefined;
    message.targetDate = object.targetDate ?? undefined;
    message.assignee = object.assignee ?? undefined;
    message.releaseName = object.releaseName ?? undefined;
    message.releaseTargetDate = object.releaseTargetDate ?? undefined;
    return message;
  },
};

function createBaseUserMessageDetails(): UserMessageDetails {
  return { userId: undefined };
}

export const UserMessageDetails: MessageFns<UserMessageDetails> = {
  encode(message: UserMessageDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMessageDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserMessageDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserMessageDetails {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : undefined,
    };
  },

  toJSON(message: UserMessageDetails): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    return obj;
  },

  create(base?: DeepPartial<UserMessageDetails>): UserMessageDetails {
    return UserMessageDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserMessageDetails>): UserMessageDetails {
    const message = createBaseUserMessageDetails();
    message.userId = object.userId ?? undefined;
    return message;
  },
};

function createBaseThreadProgressMessageDetails(): ThreadProgressMessageDetails {
  return {};
}

export const ThreadProgressMessageDetails: MessageFns<ThreadProgressMessageDetails> = {
  encode(_: ThreadProgressMessageDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadProgressMessageDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadProgressMessageDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ThreadProgressMessageDetails {
    return {};
  },

  toJSON(_: ThreadProgressMessageDetails): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ThreadProgressMessageDetails>): ThreadProgressMessageDetails {
    return ThreadProgressMessageDetails.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ThreadProgressMessageDetails>): ThreadProgressMessageDetails {
    const message = createBaseThreadProgressMessageDetails();
    return message;
  },
};

function createBaseMessageMetadata(): MessageMetadata {
  return { createdAt: undefined, chatAction: undefined };
}

export const MessageMetadata: MessageFns<MessageMetadata> = {
  encode(message: MessageMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(10).fork()).join();
    }
    if (message.chatAction !== undefined) {
      ChatSessionAction.encode(message.chatAction, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chatAction = ChatSessionAction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageMetadata {
    return {
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      chatAction: isSet(object.chatAction)
        ? ChatSessionAction.fromJSON(object.chatAction)
        : isSet(object.chat_action)
        ? ChatSessionAction.fromJSON(object.chat_action)
        : undefined,
    };
  },

  toJSON(message: MessageMetadata): unknown {
    const obj: any = {};
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.chatAction !== undefined) {
      obj.chatAction = ChatSessionAction.toJSON(message.chatAction);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageMetadata>): MessageMetadata {
    return MessageMetadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageMetadata>): MessageMetadata {
    const message = createBaseMessageMetadata();
    message.createdAt = object.createdAt ?? undefined;
    message.chatAction = (object.chatAction !== undefined && object.chatAction !== null)
      ? ChatSessionAction.fromPartial(object.chatAction)
      : undefined;
    return message;
  },
};

function createBaseSimpleAIAction(): SimpleAIAction {
  return { langfusePrompt: "", promptParams: {} };
}

export const SimpleAIAction: MessageFns<SimpleAIAction> = {
  encode(message: SimpleAIAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.langfusePrompt !== "") {
      writer.uint32(10).string(message.langfusePrompt);
    }
    globalThis.Object.entries(message.promptParams).forEach(([key, value]: [string, string]) => {
      SimpleAIAction_PromptParamsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimpleAIAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleAIAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.langfusePrompt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = SimpleAIAction_PromptParamsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.promptParams[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimpleAIAction {
    return {
      langfusePrompt: isSet(object.langfusePrompt)
        ? globalThis.String(object.langfusePrompt)
        : isSet(object.langfuse_prompt)
        ? globalThis.String(object.langfuse_prompt)
        : "",
      promptParams: isObject(object.promptParams)
        ? (globalThis.Object.entries(object.promptParams) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.prompt_params)
        ? (globalThis.Object.entries(object.prompt_params) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: SimpleAIAction): unknown {
    const obj: any = {};
    if (message.langfusePrompt !== "") {
      obj.langfusePrompt = message.langfusePrompt;
    }
    if (message.promptParams) {
      const entries = globalThis.Object.entries(message.promptParams) as [string, string][];
      if (entries.length > 0) {
        obj.promptParams = {};
        entries.forEach(([k, v]) => {
          obj.promptParams[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<SimpleAIAction>): SimpleAIAction {
    return SimpleAIAction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SimpleAIAction>): SimpleAIAction {
    const message = createBaseSimpleAIAction();
    message.langfusePrompt = object.langfusePrompt ?? "";
    message.promptParams = (globalThis.Object.entries(object.promptParams ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseSimpleAIAction_PromptParamsEntry(): SimpleAIAction_PromptParamsEntry {
  return { key: "", value: "" };
}

export const SimpleAIAction_PromptParamsEntry: MessageFns<SimpleAIAction_PromptParamsEntry> = {
  encode(message: SimpleAIAction_PromptParamsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimpleAIAction_PromptParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleAIAction_PromptParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimpleAIAction_PromptParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: SimpleAIAction_PromptParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<SimpleAIAction_PromptParamsEntry>): SimpleAIAction_PromptParamsEntry {
    return SimpleAIAction_PromptParamsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SimpleAIAction_PromptParamsEntry>): SimpleAIAction_PromptParamsEntry {
    const message = createBaseSimpleAIAction_PromptParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
